/*jslint nomen: true */
'use strict';

const $ = require('jquery');
const {handleCustomError} = require('../../utils/contentSquareHandler');
let $form, $continue, $requiredInputs, validator;

import {debounce} from '../../components/custom-lodash';

var hasEmptyRequired = function () {
    // filter out only the visible fields
    var $filteredInputs = $requiredInputs.filter(':visible');
    var requiredValues = $filteredInputs.map(function () {
        return $(this).val();
    });
    // return _(requiredValues).contains('');
    return $filteredInputs.length > 0 && $.inArray('', requiredValues) > -1;
};

var validateForm = function () {
    // only validate form when all required fields are filled to avoid
    // throwing errors on empty form
    if (!validator) {
        return;
    }
    if (!hasEmptyRequired()) {
        if (validator.form()) {
            $continue.removeAttr('disabled');
        }
    } else {
        $continue.attr('disabled', 'disabled');
    }
};

var validateEl = function (eventObject) {
    if ($(this).val() === '') {
        $continue.attr('disabled', 'disabled');
    } else {
        // enable continue button on last required field that is valid
        // only validate single field
        if (validator.element(this) && !hasEmptyRequired()) {
            $continue.removeAttr('disabled');
        } else {
            $continue.attr('disabled', 'disabled');
        }
    }

    if (!validator.element(this) && !eventObject.data.skipPushingError) {
        handleCustomError(validator?.errorList[0]?.message, 'checkoutAddressError');
    }
};

var init = function (opts) {
    if (!opts.formSelector || !opts.continueSelector) {
        throw new Error('Missing form and continue action selectors.');
    }
    $form = $(opts.formSelector);
    $continue = $(opts.continueSelector);
    validator = $form.validate();
    $requiredInputs = $('.required', $form).find(':input');
    if (opts.skipInitialValid !== true) {
        validateForm();
    }
    // start listening
    $requiredInputs.on('change blur', {skipPushingError: false}, validateEl);
    $(opts.submitButtonSelector).on('click', () => {
        let errorsArray = validator?.errorList.map(errorObject => errorObject?.message);
        // gets uniq error messages to avoid duplicates
        [...new Set(errorsArray)].forEach(uniqError => {
            if (uniqError) {
                handleCustomError(uniqError, 'checkoutAddressError');
            }
        });
    });
    $($form)
        .find('input:not(.required)')
        .on('blur', eventObject => {
            if (!validator.element(eventObject.target)) {
                handleCustomError(validator?.errorList[0]?.message, 'checkoutAddressError');
            }
        });
    $requiredInputs.filter('input:not(.email)').on('keyup', {skipPushingError: true}, debounce(validateEl, 200));
    // validate form for "useAsBilling" checkbox
    /*$('.use-same-address-row input', $form).on('change', function () {
        // timeout: should happen after the slideDown / slideUp
        setTimeout(validateForm, 500);
    });*/
};

exports.init = init;
exports.validateForm = validateForm;
exports.validateEl = validateEl;
